<div class="container-fluid" [@fadeInAnimation]>
  <div class="row">
    <div class="col-xl-3 col-lg-2"></div>
    <div class="col-xl-6 col-lg-8">
      <div class="jumbotron">
        <div class="garanti-xl-logo text-center">
          <img src="assets/img/lonnsgaranti-portal-logo.png" />
        </div>
        <div class="frontpage-text lead">
          <span [innerHTML]="'norge.start.brodtext' | translate | safehtml"></span>
        </div>
        <hr />
        <div class="row">
          <div class="col-md-3 col-lg-2"></div>
          <div class="col-md-6 col-lg-8">
            <a routerLink="/no/soknad" class="btn-garanti btn-pink w-100 mb-0">
              <fa-icon [icon]="['fas', 'pen-nib']" [fixedWidth]="true" class="me-2"></fa-icon>{{ 'norge.navbar.sok-lonnsgaranti' | translate }}
            </a>
            <a routerLink="/no/les-mer" class="btn-garanti btn-pink w-100 mt-2 mb-0">
              <fa-icon [icon]="['fas', 'info']" [fixedWidth]="true" class="me-2"></fa-icon>{{ 'norge.navbar.les-mer' | translate }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
